var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes.root }, [
    _vm.icon
      ? _c("i", {
          directives: [{ name: "b-tooltip", rawName: "v-b-tooltip" }],
          class: _vm.classes.icon,
          attrs: { title: _vm.iconTooltip }
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "chips-content" }, [_vm._t("default")], 2),
    _vm._v(" "),
    _vm.close
      ? _c("span", { staticClass: "chips-close-btn" }, [
          _c("i", { staticClass: "fas fa-times" })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }